import { UserPermissionService } from '../services/user-permission-service';
import { FeatureFlagDeclarations } from './feature-flag-declarations';
import { getLaunchDarklyProfile } from './config';
import { LogService } from '../services/log-service';

export class FeatureFlagConfigService {
  static buildFlagConfig() {
    return Object.keys(FeatureFlagDeclarations).reduce((featureFlags, flagKey) => {
      const featureFlag = FeatureFlagDeclarations[flagKey];
      return {
        ...featureFlags,
        [featureFlag.key]: featureFlag.defaultValue,
      };
    }, {});
  }

  static buildUserConfig(userId, sellerId, country, currentUserInfo, subscriptionPlanInfo, createDateUtc) {
    const name = currentUserInfo?.name;
    const username = currentUserInfo?.username;
    const email = currentUserInfo?.email;
    const isSystemAdmin = UserPermissionService.userIsSystemAdministrator(currentUserInfo?.roles);
    const sellerCreateDateUtc = Date.parse(createDateUtc);
    const billingPlanCode = subscriptionPlanInfo?.planCode ?? '';
    const billingPlanName = subscriptionPlanInfo?.planName ?? '';
    const subscriptionExpired = subscriptionPlanInfo?.isExpired ?? false;

    const partition = window.location.hostname.split('.')[0];

    return {
      key: userId,
      name,
      email,
      country,
      custom: {
        userId,
        username,
        partition,
        sellerId,
        isSystemAdmin,
        billingPlanName,
        billingPlanCode,
        subscriptionExpired,
        sellerCreateDateUtc,
      },
    };
  }

  static buildUserConfigFromBootstrap() {
    const launchDarklyProfile = getLaunchDarklyProfile();
    if (!launchDarklyProfile.length) {
      return;
    }

    let parsedProfile;
    try {
      const decodedProfile = atob(launchDarklyProfile);
      parsedProfile = JSON.parse(decodedProfile);
    } catch (e) {
      LogService.logInfo('Error parsing bootstrap profile', e);
      return;
    }

    return {
      key: parsedProfile.userId,
      name: parsedProfile.name,
      email: parsedProfile.email,
      country: parsedProfile.country,
      custom: {
        userId: parsedProfile.userId,
        username: parsedProfile.userName,
        partition: parsedProfile.partition,
        sellerId: parsedProfile.sellerId,
        isSystemAdmin: parsedProfile.isSystemAdmin,
        billingPlanName: parsedProfile.billingPlanName,
        billingPlanCode: parsedProfile.billingPlanCode,
        subscriptionExpired: parsedProfile.subscriptionExpired,
        sellerCreateDateUtc: parsedProfile.sellerCreateDateUtc,
      },
    };
  }
}
